import MediaSegmentVideoPlayer, {
  MediaSegmentVideoPlayerProps,
} from './MediaSegmentVideoPlayer';

export default MediaSegmentVideoPlayer;
export { MediaSegmentVideoPlayerProps };
